import { useEffect, useRef, useState } from "react";

export default function EditFilePickerModal({
  open,
  onClose,
  files = [],
  onSelect,
  title = "Choose a file to edit ",
}) {
  const backdropRef = useRef(null);
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (!open) setQuery("");
  }, [open]);

  const filtered = files.filter((f) => {
    const s =
      `${f.template_name || ""} ${f.file_name || ""} ${f.date || ""}`.toLowerCase();
    return s.includes(query.toLowerCase());
  });

  return (
    <div
      className={`fixed inset-0 z-[100] ${open ? "" : "pointer-events-none"}`}
      aria-hidden={!open}
    >
      {/* backdrop */}
      <div
        ref={backdropRef}
        className={`absolute inset-0 bg-black/40 transition-opacity ${
          open ? "opacity-100" : "opacity-0"
        }`}
        onClick={onClose}
      />
      {/* dialog */}
      <div
        className={`absolute left-1/2 top-1/2 w-[92vw] max-w-xl -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white shadow-xl transition-all ${
          open ? "opacity-100 scale-100" : "opacity-0 scale-95"
        }`}
        role="dialog"
        aria-modal="true"
      >
        <div className="p-5 border-b">
          <h2 className="text-lg font-semibold">{title}</h2>
        </div>

        <div className="max-h-[50vh] overflow-y-auto p-2">
          {filtered.length === 0 ? (
            <div className="p-6 text-sm text-gray-500">No files found.</div>
          ) : (
            <ul className="divide-y">
              {filtered.map((f) => (
                <li key={f.file_id}>
                  <button
                    onClick={() => onSelect(f)}
                    className="w-full text-left p-3 hover:bg-gray-50 flex items-start justify-between gap-3"
                  >
                    <div>
                      <div className="text-sm font-medium">
                        {f.template_name || f.file_name || "Untitled File"}
                      </div>
                      <div className="text-xs text-gray-500 mt-0.5">
                        {f.file_name}
                        {f.date ? ` • ${f.date}` : ""}
                      </div>
                    </div>
                    <svg
                      className="w-5 h-5 text-gray-400 shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="p-4 border-t flex justify-end">
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-sm rounded-lg border hover:bg-gray-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
